import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAXwf1z_HhrB5MKCf5aCnVUnUz89Uyz4A8",
  authDomain: "my-karaoke-world.firebaseapp.com",
  projectId: "my-karaoke-world",
  storageBucket: "my-karaoke-world.firebasestorage.app",
  messagingSenderId: "448846533841",
  appId: "1:448846533841:web:5df8ea2222e3f529f561f0",
  measurementId: "G-0HMXH8192Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// Never attempt to connect to local emulators in production builds.
// In development, default to using emulators unless explicitly disabled.
const useEmulator =
  process.env.NODE_ENV === 'development' &&
  process.env.VUE_APP_USE_FIREBASE_EMULATOR !== 'false';

if (useEmulator) {
  console.log('Connecting to Firebase emulators...');
  connectFirestoreEmulator(db, 'localhost', 9101);
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectAuthEmulator(auth, 'http://localhost:9099');
  console.log('Connected to Firebase emulators');
} else {
  console.log('Using production Firebase services');
}

export { db, functions, analytics, logEvent, auth };
